import { render, staticRenderFns } from "./SellMultipleProductsPlus.vue?vue&type=template&id=2b048ea8&scoped=true"
import script from "./SellMultipleProductsPlus.vue?vue&type=script&lang=js"
export * from "./SellMultipleProductsPlus.vue?vue&type=script&lang=js"
import style0 from "./SellMultipleProductsPlus.vue?vue&type=style&index=0&id=2b048ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b048ea8",
  null
  
)

export default component.exports